import axios, { AxiosResponse } from "axios";
import {ICategory, IDocumentHistory, IUploadDocument, NameByLang} from "./manage-reestr-list.type";

/**
 * Список реестров (категорий)
 */
export const documentHistoryCategories = (): Promise<AxiosResponse<ICategory[]>> => {
  return axios.get<ICategory>(`/services/isnaportal/open-api/admin/document-history/categories`);
};

/**
 * Получение данных по выбранной категории
 * @param importDocumentCategory
 */
export const documentHistory = (importDocumentCategory: string): Promise<AxiosResponse<IDocumentHistory>> => {
  return axios.get<IDocumentHistory>(`/services/isnaportal/open-api/admin/document-history`, {
    params: {
      importDocumentCategory
    }
  });
};

/**
 * Получение шаблона документа
 * @param documentCategory
 * @param language
 */
export const downloadDocumentHistoryTemplate = (
    documentCategory: string,
    language: string
): Promise<AxiosResponse> => {
  return axios.get(`/services/isnaportal/open-api/admin/document-history/download/template`, {
    responseType: "arraybuffer",
    params: {
      documentCategory,
      language
    }
  });
};

/**
 * Получение файла по id
 * @param id
 */
export const downloadFileById = (id: number): Promise<AxiosResponse> => {
  return axios.get(`/services/isnaportal/open-api/admin/document-history/download/${id}`, {
    responseType: "arraybuffer",
  });
};

/**
 * Добавление  документа
 * @param data
 */
export const uploadDocument = (data: IUploadDocument): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/admin/document-history/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

/**
 * Публикация документа
 */
export const publishDocument = (documentHistoryId: number): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/admin/document-history/publish/${documentHistoryId}`, []);
};

/**
 * Архивациия записи
 */
export const archiveDocument = (documentHistoryId: number): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/admin/document-history/archive/${documentHistoryId}`, []);
};

/**
 * Изменение имени в документе
 */
export const changeDocument = (data: NameByLang, documentHistoryId: number): Promise<AxiosResponse> => {
  return axios.post(`/services/isnaportal/open-api/admin/document-history/${documentHistoryId}/name`, data);
};
